import React from 'react';
import PropTypes from 'prop-types';
import { SmsReminders } from '@ramsey-plus-components/sms-reminders';
import Rails from '@rails/ujs';

const SmsRemindersContainer = ({ email, klaviyoListId }) => {
  return (
    <SmsReminders
      email={email}
      klaviyoListId={klaviyoListId}
      csrfToken={Rails.csrfToken()}
    />
  );
};

SmsRemindersContainer.propTypes = {
  email: PropTypes.string,
  klaviyoListId: PropTypes.string
};

export default SmsRemindersContainer;
